export default __webpack_public_path__ + "static/media/Interactive Map.6e565531.svg";